// extracted by mini-css-extract-plugin
export default {"item":"ovp1Z3XbUDdv3mGkRkR_","color":"ijk3aHIKjwWxSKTcBJPx","name":"VMoHor_pK2TvMZOjftyw"};